export default __webpack_public_path__ + "static/media/ViewRolesCategories.4d15e873.svg";